module.exports = __webpack_public_path__ + "img/kp6.3a3536c9.png";